// services/musicCatalog.js
//
// The Free To Use catalogue, fetched. URLs, the track shape and filtering live
// in shared/backgroundMusic.js (synced from the app), so both clients build
// the same requests and read the same tracks; this file only does the I/O.
import {
  categoriesUrl,
  searchTracksUrl,
  categoryTracksUrl,
  featuredTracksUrl,
  trackUrl,
  normalizeTrack,
  normalizeTrackList,
  pickCategories,
} from '../shared/backgroundMusic';

async function getJson(url, signal) {
  const res = await fetch(url, { signal, headers: { Accept: 'application/json' } });
  if (!res.ok) throw new Error(`Music catalogue returned ${res.status}`);
  const json = await res.json();
  if (json && json.ok === false) throw new Error(json.error || 'Music catalogue error');
  return json;
}

let categoriesPromise = null;

export function fetchMusicCategories() {
  if (!categoriesPromise) {
    categoriesPromise = getJson(categoriesUrl())
      .then(pickCategories)
      .catch((error) => {
        categoriesPromise = null;
        throw error;
      });
  }
  return categoriesPromise;
}

export async function searchMusic(query, { signal } = {}) {
  return normalizeTrackList(await getJson(searchTracksUrl(query), signal));
}

export async function fetchCategoryMusic(categoryId, { signal } = {}) {
  return normalizeTrackList(await getJson(categoryTracksUrl(categoryId), signal));
}

export async function fetchFeaturedMusic({ signal } = {}) {
  return normalizeTrackList(await getJson(featuredTracksUrl(), signal));
}

export async function fetchMusicTrack(trackId, { signal } = {}) {
  const json = await getJson(trackUrl(trackId), signal);
  return normalizeTrack(json && json.data);
}
